import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const jsmWorkItemServiceRequestRoute: InvariantJiraRoute = {
	name: 'jsm-work-item-service-request',
	path: '/jira/servicedesk/service-requests/:issueKey',
	exact: true,
};
